import AppRoutes from "./routing/AppRoutes";
import GlobalErrorBoundary from "./components/global.error.boundary/GlobalErrorBoundary";
import { StyledEngineProvider } from "@mui/material/styles";
import React from "react";
import AppThemeProvider from "./themes/ThemeProvider";
import store from "./store/store";
import { BrowserRouter } from "react-router-dom";
import { Provider as StoreProvider } from "react-redux";
import Support from "./features/support/Support";
import WithEnabledFeature from "./components/HOC/WithEnabledFeature";
import { features } from "./constants";
import "react-phone-number-input/style.css";

const SupportEnabled = WithEnabledFeature(Support);

const App = () => (
  <StoreProvider store={store}>
    <GlobalErrorBoundary>
      <StyledEngineProvider injectFirst>
        <AppThemeProvider>
          <BrowserRouter basename={process.env.REACT_APP_ROUTES_PREFIX}>
            <AppRoutes />
          </BrowserRouter>
        </AppThemeProvider>
      </StyledEngineProvider>
      <SupportEnabled feature={features.ZENDESK} />
    </GlobalErrorBoundary>
  </StoreProvider>
);

export default App;
